<template>
  <v-tabs v-model="tab" class="elevation-3" height="400">
    <v-tab href="#tab-notes">
      <notes-card></notes-card>
    </v-tab>
    <v-tab href="#tab-registration">
      <registration-card :info="usersStatistics" />
    </v-tab>
    <v-tab href="#tab-habitation">
      <habitation-card
        :info="generalStatisticBusinessCustomers"
      ></habitation-card>
    </v-tab>

    <v-tab href="#tab-task-reports">
      <task-reports-card :info="taskReportsStatistics" />
    </v-tab>

    <v-tab href="#tab-scheduling-conflicts">
      <scheduling-conflicts-card :info="requestVacationsStatistics" />
    </v-tab>

    <v-tab href="#tab-map">
      <dashboard-map-card />
    </v-tab>

    <v-tab-item value="tab-registration">
      <v-card flat tile>
        <registration />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-habitation">
      <v-card flat tile>
        <habitation-list :items="businessCustomers"></habitation-list>
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-notes">
      <v-card flat tile>
        <notes-list :items="notes"></notes-list>
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-task-reports">
      <v-card flat tile>
        <task-reports />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-scheduling-conflicts">
      <v-card flat tile>
        <scheduling-conflicts />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-map">
      <v-card flat tile>
        <dashboard-map :building-complexes="buildingComplexes" />
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapActions } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { StatisticsService } from '@/services/statistics.service';

export default {
  name: 'DashboardTabs',

  components: {
    DashboardMap: () =>
      import('@/modules/statistic/components/Map/DashboardMap'),
    DashboardMapCard: () =>
      import('@/modules/statistic/components/Map/DashboardMapCard'),
    RegistrationCard: () =>
      import('@/modules/statistic/components/Registration/RegistrationCard'),
    Registration: () =>
      import('@/modules/statistic/components/Registration/Registration'),
    HabitationCard: () =>
      import('@/modules/statistic/components/HabitationCard'),
    HabitationList: () =>
      import('@/modules/statistic/components/HabitationList'),
    NotesCard: () => import('@/modules/statistic/components/Notes/NotesCard'),
    NotesList: () => import('@/modules/statistic/components/Notes/NotesList'),
    TaskReportsCard: () =>
      import('@/modules/statistic/components/TaskReports/TaskReportsCard'),
    TaskReports: () =>
      import('@/modules/statistic/components/TaskReports/TaskReports'),
    SchedulingConflicts: () =>
      import('@/modules/statistic/components/Scheduling/SchedulingConflicts'),
    SchedulingConflictsCard: () =>
      import(
        '@/modules/statistic/components/Scheduling/SchedulingConflictsCard'
      )
  },

  mixins: [i18nRefreshData],

  data: () => ({
    usersStatistics: {},
    generalStatisticBusinessCustomers: {},
    businessCustomers: [],
    notes: [],
    taskReportsStatistics: {},
    requestVacationsStatistics: {},
    buildingComplexes: [],
    tab: null,
    error: null
  }),

  created() {
    this.refreshData();
    this.retrieveUsersStatistics()
      .then(({ data }) => {
        this.usersStatistics = data;
      })
      .catch(this.errorsHandler);

    this.$store
      .dispatch('statistic/retrieveHabitation')
      .then(({ data }) => {
        this.generalStatisticBusinessCustomers = data.general_statistic;
        this.businessCustomers = data.business_customers_statistic;
      })
      .catch(this.errorsHandler);

    this.$store
      .dispatch('statistic/retrievePersons')
      .then(({ data }) => {
        this.notes = data.data;
      })
      .catch(this.errorsHandler);

    this.retrieveTaskReportsStatistics()
      .then(({ data }) => {
        this.taskReportsStatistics = data;
      })
      .catch(this.errorsHandler);

    StatisticsService.getRequestVacationConflictReports()
      .then(({ data }) => {
        this.requestVacationsStatistics = data.data;
      })
      .catch(this.errorsHandler);
  },

  methods: {
    ...mapActions('statistic', [
      'retrieveUsersStatistics',
      'retrieveTaskReportsStatistics',
      'retrieveMapBuildingComplexes'
    ]),

    refreshData() {
      this.retrieveMapBuildingComplexes()
        .then(({ data }) => {
          this.buildingComplexes = data.data;
        })
        .catch(this.errorsHandler);
    },

    errorsHandler({ message }) {
      console.log('Error', message);
    }
  }
};
</script>
